import type { ReactNode } from "react";

import { MarketingPageLayout } from "../components/MarketingPageLayout";
import { BottomCTA } from "../sections/BottomCTA";

export function UseCaseLayout({ children }: { children: ReactNode }) {
  return (
    <MarketingPageLayout current="use-cases">
      {children}
      <BottomCTA />
    </MarketingPageLayout>
  );
}
